// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var TicketPark$ReactHooksTemplate = require("./ticketPark.res.js");

function TicketParkView(props) {
  var activity = props.activity;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Ticket Parked",
                              className: "text-sm font-semibold"
                            }),
                        JsxRuntime.jsx("div", {
                              children: TicketPark$ReactHooksTemplate.parkedBy(activity),
                              className: "text-xs font-normal"
                            })
                      ],
                      className: "flex justify-between text-darkcharcoal"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        "Parked Till: ",
                        TicketPark$ReactHooksTemplate.parkedTill(activity).format("lll")
                      ],
                      className: "flex text-xs font-normal mt-2"
                    }),
                JsxRuntime.jsx("div", {
                      children: TicketPark$ReactHooksTemplate.comment(activity),
                      className: "mt-2 text-xs font-normal"
                    })
              ]
            });
}

var make = TicketParkView;

exports.make = make;
/* react/jsx-runtime Not a pure module */
